const updateThreads = (threads, payload, shouldRemove) => {
    let newThreads = [...threads]

    const {
        AccountId,
        UserId,
        ThreadId,
        Channel,
        LeadSource,
        Initiator,
        StopAiCommunication,
        ConversationId,
    } = payload

    // console.log('[socketHandler updatethreads] payload:', payload)
    // console.log('[socketHandler updatethreads] newThreads:', newThreads)

    const targetThreadIndex = newThreads.findIndex(
        thread => thread.account === AccountId
            // thread.user === UserId &&
            && thread.conversationId === ConversationId
    )

    // 1. New message (new thread)
    if (targetThreadIndex > -1) {
        const targetThread = newThreads[targetThreadIndex]
        if (!shouldRemove && targetThread.user !== UserId) {
            // inbox item changes after update, but you stay on same lead, userId removed from socket activeKey
            // return newThreads
        }

        // 2. New message (existing thread)
        newThreads.splice(targetThreadIndex, 1)
    }
    // console.log('HEREE')
    // console.log('HEREE')
    // console.log('HEREE')
    // console.log('HEREE')

    newThreads = [...newThreads]

    if (shouldRemove) {
        return newThreads
    }

    newThreads = [
        {
            account: AccountId,
            user: UserId,
            thread: ThreadId,
            channel: Channel,
            source: JSON.stringify(LeadSource),
            initiator: Initiator,
            timestamp: 0,
            stopped: Boolean(StopAiCommunication),
            insertedFromRedux: true,
            conversationId: ConversationId,
        },
        ...newThreads,
    ]

    return newThreads
}

export default (state, action) => {
    const { payload } = action

    const {
        AccountId,
        AccountIsLive,
        UserId,
        Initiator,
        MessageStatus,
        MessageId,
        ClassifierResponse,
        FollowUp,
        StopAiCommunication,
        ConversationId,
        // Channel,
    } = payload

    const { loadingInbox } = state

    let { inboxData, historicalDialogue } = state
    const { type } = state

    let newState = { ...state }

    if (loadingInbox) {
        return newState
    }

    let { threads } = inboxData

    // If communication stopped
    if (StopAiCommunication) {
        if (!historicalDialogue) {
            return newState
        }

        // Check if it's message from another thread
        const [firstElement] = historicalDialogue

        // Continue only if message from current thread
        if (
            firstElement.AccountId !== AccountId
            || firstElement.UserId !== UserId
            || firstElement.ConversationId !== ConversationId
        ) {
            return newState
        }
    }

    // Handle pending inbox
    // if (type === 'pending' && AccountIsLive) {
    //  return newState
    // }

    if (
        type !== 'pending'
        && (!AccountIsLive || (Initiator === 'human' && !ClassifierResponse))
    ) {
        return newState
    }
    // End of pending inbox

    if (Initiator === 'bot' && FollowUp) {
        return newState
    }

    // 0. If sent automatically, remove if INBOX
    if (Initiator === 'bot' && MessageStatus !== 'PROCESSING_NOW') {
        console.log('Remove from inbox!')

        const shouldRemove = Boolean(type === 'inbox')

        threads = updateThreads(threads, payload, shouldRemove)

        if (historicalDialogue) {
            const [firstElement] = historicalDialogue

            if (
                firstElement
                && firstElement.AccountId === AccountId
                // firstElement.UserId === UserId &&
                && firstElement.ConversationId === ConversationId
            ) {
                const messageIndexInConvo = historicalDialogue.findIndex(
                    element => element.MessageId === MessageId
                )

                if (messageIndexInConvo === -1) {
                    historicalDialogue = [...historicalDialogue, payload]

                    newState = {
                        ...newState,
                        historicalDialogue: [...historicalDialogue],
                    }
                } else {
                    historicalDialogue[messageIndexInConvo] = payload

                    newState = {
                        ...newState,
                        historicalDialogue: [...historicalDialogue],
                    }
                }
            }
        }

        newState = { ...newState, inboxData: { ...inboxData, threads } }

        return newState
    }

    const shouldSkipTrigger = Boolean(
        Initiator === 'human' && ClassifierResponse
    )

    let triggerInfo
    if (!shouldSkipTrigger) {
        console.log('!shouldSkipTrigger')
        threads = updateThreads(threads, payload)

        triggerInfo = {
            id: Date.now(),
            initiator: payload.Initiator,
            key: `${AccountId}/${UserId}/${ConversationId}`,
        }
    }

    inboxData = { ...inboxData, threads }

    newState = { ...newState, inboxData }

    if (triggerInfo) {
        newState = { ...newState, triggerInfo }
    }

    // 3. New message (bot answer) PROCESSING_NOW
    if (historicalDialogue && historicalDialogue.length) {
        const [firstElement] = historicalDialogue

        // If message from another thread
        if (
            firstElement.AccountId !== AccountId
            // firstElement.UserId !== UserId ||
            || firstElement.ConversationId !== ConversationId
        ) {
            return newState
        }

        const messageIndex = historicalDialogue.findIndex(
            element => element.MessageId === payload.MessageId
        )

        // If new message
        if (messageIndex === -1) {
            historicalDialogue = [...historicalDialogue, payload]
        } else if (payload.Initiator === 'human') {
            // if message exists, but human message was updated (reclassify, ...)
            historicalDialogue[messageIndex] = payload

            historicalDialogue = [...historicalDialogue]
        }
    }

    newState = { ...newState, historicalDialogue }

    return newState
}

// cloudwatch
// const authorization = localStorage.getItem(
//  'pulsarBotPlatform_operatorToken'
// )
// axios({
//  method: 'POST',
//  url: '/api/operators/logs',
//  headers: { authorization },
//  data: {
//      data: { state, action },
//      action: 'Reducer socketHandler | Top of function',
//      source: 'CLIENT',
//      time: new Date().toString(),
//  },
// }).catch(error => console.log('Cloudwatch error'))
